import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class RecordTrashTariff extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/tariff/trash'
    super(store, path)
  }
}
